import { baseApi } from '@krp/client-runtime'

import type { ServiceReadiness, ServiceVersion } from '../model/types'
import { decodeGatewayReadiness, decodeGatewayVersion } from './contracts'
import { PLATFORM_DIAGNOSTICS_URLS } from './urls'

export const diagnosticsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // Версия — строка шлюза в «О приложении»; без автоповтора, иначе отказ шлюза спрашивался бы трижды.
    platformGatewayVersion: build.query<ServiceVersion, void>({
      query: () => ({ url: PLATFORM_DIAGNOSTICS_URLS.gatewayStatus, decode: decodeGatewayVersion, noRetry: true }),
    }),
    /**
     * Готовность — всегда свежая и без повтора: старый «готов» хуже, чем его
     * отсутствие, а повтор прячет ту самую недоступность, которую проверка
     * показывает (AU1a п. 1). Повторить может человек кнопкой.
     */
    platformGatewayReady: build.query<ServiceReadiness, void>({
      query: () => ({ url: PLATFORM_DIAGNOSTICS_URLS.gatewayReady, decode: decodeGatewayReadiness, noRetry: true }),
      keepUnusedDataFor: 0,
    }),
  }),
})

export const { platformGatewayVersion, platformGatewayReady } = diagnosticsApi.endpoints
